import { FC } from "react";
import { NoProps } from "../../shared/types";
import NavlinkOutline from "../../widgets/NavlinkOutline";

const BoardHelp: FC<NoProps> = () => {
    return <div>
        <div><span>halp</span></div>
        <div><NavlinkOutline toPath="/board" linkText="back to the shit..." /></div>
    </div>
}

export default BoardHelp